export const createDebouncer = (duration_ms: number) => {
    let timeoutId = -1;

    return {
        call: (fn: () => void) => {
            clearTimeout(timeoutId);
            timeoutId = window.setTimeout(fn, duration_ms);
        },
        cancel: () => {
            clearTimeout(timeoutId);
        },
    };
};
